<ng-container *ishNotFeature="'dotCmsUve'">
  <h1 class="sr-only">{{ 'seo.title.home' | translate }}</h1>
  <ish-content-include includeId="include.homepage.content.pagelet2-Include" />
</ng-container>
<!-- <ng-container *ishFeature="'dotCms'">
  <custom-lazy-dot-cms-default-page />
</ng-container> -->

<ng-container *ishFeature="'dotCmsUve'">
  <ng-container *ngComponentOutlet="lazyPageComponent$ | async" />
</ng-container>
